<template>

  <div class="container">
    <ul class="nav justify-content-end">
      <li class="nav-item">
        <input type="button"  class="btn btn-link" @click="logout" value="Logout">
      </li>
    </ul>
    <Cards :connects="connects" :runners="runners"/>

    <div class="row pt-5">
      <div class="col col-lg-12 col-md-12 col-sm-12">
        <h4 class="text-white">Corredores por kms</h4>
        <Chart v-if="loaded" :chart-data="datacollection"/>

        <download-excel
            class="btn btn-outline-primary float-right"
            :data="json_data"
            :fields="json_fields"
            worksheet="Total corredores"
            name="Corredores.xls">
          Descargar
          <span class="material-icons icon-item">cloud_download</span>
        </download-excel>

      </div>

    </div>

  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import Cards from "@/components/Cards.vue";
import Chart from "@/components/Chart.vue";
import firebase from 'firebase/app';
import 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAgSSqoJ-w5k5hCCOwo-tnwudXZ8QwCNWY",
  authDomain: "k630-5b0ed.firebaseapp.com",
  databaseURL: "https://k630-5b0ed.firebaseio.com",
  projectId: "k630-5b0ed",
  storageBucket: "k630-5b0ed.appspot.com",
  messagingSenderId: "118755331504",
  appId: "1:118755331504:web:0714bc76e599f0ec4a1a75",
  measurementId: "G-FJC78N3GLV"
};
firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();

export default {
  name: 'Home',
  components: {
    Cards,
    Chart
  },
  methods: {
    logout: function() {
      firebase.auth().signOut().then(() => {
        this.$router.replace('login')
      })
    },
    async auth() {
      await firebase.auth().signInAnonymously().catch(function (error) {
        // Handle Errors here.
        let errorCode = error.code;
        let errorMessage = error.message;
        console.log(errorCode, "Houston, we've had a problem here", errorMessage);
        console.log(error);
      });

      await firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          // User is signed in.
          let isAnonymous = user.isAnonymous;
          let uid = user.uid;
          console.log(isAnonymous, "I'm in!", uid);

        } else {
          // User is signed out.
        }

      });
    },
    async updateData() {
      db.collection("users")
          .onSnapshot( async (snapshot) => {
            let allConects = 0;
            let allPositions = Array(101).fill(0);

            this.runners.total =  snapshot.docs.length;

            let allResults = await snapshot.docs.forEach( (change) => {

              const data = change.data();

              if (data.isConnected){
                allConects++;
              }
              let position = (data.position/100|0);
              allPositions[position]++;

            });

            console.log("allPositions: ", allPositions);
            console.log(allResults);
            this.datacollection = allPositions;
            this.json_data = [];

            this.datacollection.forEach((v, k) => {
              this.json_data.push({
                km: `${((k*100)/1000)} km`,
                quantity: v
              });
            })

            this.connects.total = allConects;

          }, (error) => {
            console.error("Ha sucedido algo", error);
          });
    }
  },
  data(){
    return {
      connects : {
        total: 0,
        title: "Conectados actuales"
      },
      runners : {
        total: 0,
        title: "Total corredores"
      },
      loaded: false,
      datacollection: [],
      json_data: [],
      json_fields: {
        'Posición en Kms': 'km',
        'Cantidad de Jugadores': 'quantity'
      },
    }
  },
  async mounted () {
    //await this.auth();
    this.loaded = false
    try {
      await this.updateData();
      this.loaded = true;
    } catch (e) {
      console.error(e)
    }
  }
}
</script>

<style>
html, body {
  width: 100vm;
  height: 100vh;
  background-color: #191c24 !important;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 30px;
}

.material-icons {
  vertical-align: middle;
  line-height: 0 !important;
  position: relative;
  top: -1px;
}


.btn-outline-primary, .wizard > .actions .disabled a {
  color: #0090e7;
  border-color: #0090e7;
}

</style>
